import { isFitanu } from 'config/theme';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from './button.style';

const ContactButton = () => {
  const { t } = useTranslation();
  return (
    <Button
      href={
        isFitanu()
          ? t("footer.fitanuContactLink")
          : t("footer.martesContactLink")
      }
      variant="outlined"
    >
      {t("footer.contact")}
    </Button>
  );
};

export default ContactButton;
